// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__JsMTR","subtitle":"title_subtitle__YL_Y2","heart":"title_heart__X_mQv"};